
import { SalesMetricsGrid } from "../SalesMetricsGrid";
import { useSalesDialogs } from "@/hooks/useSalesDialogs";
import { SalesMetricsBasic } from "@/pages/admin/sales";
import { SalesDetailsDialog } from "./SalesDetailsDialog";

interface SalesMetricsSectionProps {
  metrics?: SalesMetricsBasic;
  isHistorical?: boolean;
}

export const SalesMetricsSection = ({ 
  metrics: propMetrics, 
  isHistorical = false 
}: SalesMetricsSectionProps) => {
  const { 
    showDailyDetails,
    showWeeklyDetails,
    showMonthlyDetails,
    showYearToDateDetails,
    setShowDailyDetails, 
    setShowWeeklyDetails, 
    setShowMonthlyDetails, 
    setShowYearToDateDetails 
  } = useSalesDialogs();
  
  const handleDailyClick = () => setShowDailyDetails(true);
  const handleWeeklyClick = () => setShowWeeklyDetails(true);
  const handleMonthlyClick = () => setShowMonthlyDetails(true);
  const handleYearlyClick = () => setShowYearToDateDetails(true);
  
  return (
    <div className="mb-8 lg:mb-10">
      <h2 className="text-xl font-bold mb-4 text-gray-800">
        {isHistorical ? 'Historical Sales Metrics' : 'Sales Metrics'}
      </h2>
      <SalesMetricsGrid 
        salesMetrics={propMetrics} 
        isLoading={!propMetrics}
        onDailyClick={handleDailyClick}
        onWeeklyClick={handleWeeklyClick}
        onMonthlyClick={handleMonthlyClick}
        onYearlyClick={handleYearlyClick}
      />
      
      {/* Dialogs for showing detailed policy data */}
      <SalesDetailsDialog 
        title="Daily Sales Details"
        open={showDailyDetails}
        onOpenChange={setShowDailyDetails}
        totalAmount={propMetrics?.dailyTotal}
        policies={propMetrics?.dailyPolicies || []}
        timeframe="daily"
      />
      
      <SalesDetailsDialog 
        title="Weekly Sales Details"
        open={showWeeklyDetails}
        onOpenChange={setShowWeeklyDetails}
        totalAmount={propMetrics?.weeklyTotal}
        policies={propMetrics?.weeklyPolicies || []}
        timeframe="weekly"
      />
      
      <SalesDetailsDialog 
        title="Monthly Sales Details"
        open={showMonthlyDetails}
        onOpenChange={setShowMonthlyDetails}
        totalAmount={propMetrics?.monthlyTotal}
        policies={propMetrics?.monthlyPolicies || []}
        timeframe="monthly"
      />
      
      <SalesDetailsDialog 
        title="Year to Date Sales Details"
        open={showYearToDateDetails}
        onOpenChange={setShowYearToDateDetails}
        totalAmount={propMetrics?.yearlyTotal}
        policies={propMetrics?.yearlyPolicies || []}
        timeframe="yearly"
      />
    </div>
  );
};
